import { LAMPORTS_PER_SOL, PublicKey } from "@solana/web3.js";

/** Mint rent, metadata account, and network fee on top of the displayed platform fee. */
export const TOKEN_CREATE_RENT_BUFFER_LAMPORTS = 20_000_000;

export function requiredLamportsForTokenCreate(requiredSol) {
  const feeLamports = Math.ceil(Number(requiredSol) * LAMPORTS_PER_SOL);
  if (!Number.isFinite(feeLamports) || feeLamports < 0) {
    throw new Error("Invalid token creation fee.");
  }
  return feeLamports + TOKEN_CREATE_RENT_BUFFER_LAMPORTS;
}

export function insufficientSolMessage(balanceLamports, requiredLamports) {
  const have = (balanceLamports / LAMPORTS_PER_SOL).toFixed(4);
  const need = (requiredLamports / LAMPORTS_PER_SOL).toFixed(4);
  return `Insufficient funds. Your wallet has ${have} SOL and this needs at least ${need} SOL. Add SOL and try again. The request was not sent to your wallet.`;
}

/**
 * Returns an insufficient-funds message when the connected wallet cannot pay.
 * Returns null when the balance covers the fee. Does not contact the wallet.
 */
export async function readInsufficientSolMessage({
  connection,
  walletAddress,
  requiredSol,
}) {
  if (!connection || !walletAddress) return null;
  const requiredLamports = requiredLamportsForTokenCreate(requiredSol);
  const balance = await connection.getBalance(
    new PublicKey(walletAddress),
    "confirmed",
  );
  if (balance >= requiredLamports) return null;
  return insufficientSolMessage(balance, requiredLamports);
}
